export default {
  menu:{
    services: 'Services',
    mobile_topup: 'Mobile Topup',
    egift: 'Egift',
    about: 'About',
    our_company: 'Our Company',
    terms_and_conditions: 'Terms And Conditions',
    privacy_policy: 'Privacy Policy',
    about_shopicel: 'About Shopicel',
    faqs: 'FAQ',
    follow_us: 'Follow Us',
    contact_us: 'Contact Us',
    lock_screen: 'Lock Screen',
    logout: 'Logout'
  },
  label:{
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    home: 'Home',
    sign_out: 'Sign Out',
    my_account: 'My Account',
    select_contact: 'Select Contact',
    email: 'Email',
    service: 'Service',
    from_date: 'From',
    to_date: 'To',
    from: 'From',
    to: 'To',
    email_address: 'Email Address',
    name: 'Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    language: 'Language',
    country: 'Country',
    select_country: 'Select Country',
    dob: 'Date Of Birth',
    phone: 'Phone',
    password: 'Password',
    password_confirmation: 'Password Confirmation',
    subscribe_to_newsletter: 'Subscribe To Newsletter',
    forgot_password: 'Forgot your password?',
    edit_profile: 'Edit Profile',
    contacts: 'Contacts',
    payment_methods: 'Payment Methods',
    history: 'History',
    date: 'Date',
    no_transactions: 'No transactions',
    loading_data: 'Loading Data',
    view: 'View',
    login: 'Login',
    register: 'Register',
    create_contact: 'Create Contact',
    update_contact: 'Update Contact',
    use_existing: 'Use Existing',
    edit: 'Edit',
    delete: 'Delete',
    sender_phone: 'Sender Phone Number',
    receiver_phone: 'Receiver Phone Number',
    receiver_country: 'Receiver Country',
    read: 'Read',
    terms_and_conditions: 'Terms and Conditions',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    domestic_mobile_top_up: 'Domestic Mobile TopUp',
    international_calls: 'International Calls',
    mobile_top_up: 'Mobile Top Up',
    international_egift: 'International Egift',
    money_transfer: 'Money Transfer',
    change_password: 'Change Password',
    update_password: 'Update Password',
    for_more_information: 'For More Information',
    call_customer_assistance: 'Call Customer Assistance',
    send_email_to: 'Send Email To',
    subscribe: 'Subscribe',
    message: 'Message',
    subject: 'Subject',
    pick_a_day: 'Pick a Day',
    new_password: 'New Password',
    new_password_confirmation: 'New Password Confirmation',
    name_on_card: 'Name on Card',
    card_number: 'Card Number',
    expiration: 'Expiration',
    cvc: 'CVC',
    street_address: 'Street Address',
    recipient: 'Recipient',
    recipient_name: 'Recipient Name',
    next: 'Next',
    product: 'Product',
    product_selection: 'Product Selection',
    select: 'Select',
    update_profile: 'Update Profile',
    recipient_selection: 'Recipient Selection',
    back_to_recipient_selection: 'Back to Recipient Selection',
    checkout: 'Checkout',
    new_topup: 'New Topup',
    empty_cart: 'Empty Cart',
    order_summary: 'Order Summary',
    pay: 'Pay',
    payment_method: 'Payment Method',
    card_details: 'Card Details',
    billing_address: 'Billing Address',
    city_town: 'City / Town',
    state_province_region: 'State / Province / Region',
    zip_code: 'Zip Code',
    add_card: 'Add Card',
    subtotal: 'Subtotal',
    total: 'Total',
    place_order: 'Place Order',
    card_ending_in: '{brand} ending in {last4}',
    new_payment_method: 'New Payment Method',
    add_to_cart: 'Add To Cart',
    slides: 'Slides',
    slug: 'Slug',
    status: 'Status',
    proceed_to_checkout: 'Proceed To Checkout',
    shoping_cart: 'Shoping Cart',
    price: 'Price',
    edit_order: 'Edit Order'




  },
  header:{
    login: 'Login'
  },
  button:{
    create_account: 'Create Free Account',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    login: 'Login',
    register: 'Register',
    update_profile: 'Update Profile',
    update: 'Update',
    create: 'Create',
    filter: 'Filter',
    add_contact: 'Add Contact',
    add_slide: 'Add Slide',
    submit: 'Submit'

  },
  text:{
    your_credit_and_debit_cards: 'Your credit and debit cards',
    add_new_payment_method: 'Add a new payment method',
    credit_or_debit_card: 'Credir or debit card',
    we_accept_all_major_cards: 'We accept all major credit and debit cards',

  },
  message:{
    profile_updated: 'Profile updated',
    page_not_found: 'Page not found',
    page_not_found_message: 'Sorry, an error has occurred. Requested page not found!',

    profile_updated_successfully: 'User profile updated successfully',

    order_placed: 'Order placed',
    you_can_check_your_order_status: 'You can check your order status in your history',

    login_register_message: 'Don\'t have an account?',
    create_one_here: 'Create one here',
    register_login_message: 'Already have an account?',
    click_here_to_login: 'Click here to login',
    forgot_password: 'Forgot Password or Security Code?',
    error_creating_contact: 'Error creating contact',
    error_updating_contact: 'Error updating contact',
    error_deleting_contact: 'Error deleting contact',

    error_creating_slide: 'Error creating slide',
    error_updating_slide: 'Error updating slide',
    error_deleting_slide: 'Error deleting slide',



    error_updating_password: 'Error updating password',
    password_updated: 'Password updated successfully',
    invalid_form_data: 'Invalid form data',

    accept_topup_terms_and_conditions: 'Acept terms and conditions',

    auth_sign_in_error: 'Error authenticating user',
    auth_sign_up_error: 'Error signing up user',

  },

  auth:{
    invalid_email: 'Invalid email',
    weak_password: 'Password should be at least 6 characters',
    wrong_password: 'The password is invalid or the user does not have a password',
    email_already_in_use: 'The email address is already in use by another account',
    requires_recent_login: 'This operation is sensitive and requires recent authentication. Log in again before retrying this request',
    popup_closed_by_user: 'The popup has been closed by the user before finalizing the operation',
    cancelled_popup_request: 'User did not grant your application the permissions it requested',
    asd: 'This operation has been cancelled due to another conflicting popup being opened.'
  },

  stripe:{
    incomplete_number: 'Your card number is incomplete',
    invalid_number: 'Your card number is invalid',
    incomplete_cvc: 'Your card\'s security code is incomplete',
    incomplete_expiry: 'Your card\'s expiration date is incomplete',
    invalid_expiry_year_past: 'Your card\'s expiration year is in the past'
  },

  page_headers:{
    common:{
      title: 'Closer to your family',
      description: 'We make it simple and affordable to recharge a prepaid mobile phone in the United States — even your own'
    },
    about_us:{
      title: 'Closer to your family',
      description: 'We make it simple and affordable to recharge a prepaid mobile phone in the United States — even your own'
    },
    contact_us:{
      title: 'Closer to your family',
      description: 'We make it simple and affordable to recharge a prepaid mobile phone in the United States — even your own'
    },
    faqs:{
      title: 'Closer to your family',
      description: 'We make it simple and affordable to recharge a prepaid mobile phone in the United States — even your own'
    },
    terms_and_conditions:{
      title: 'Closer to your family',
      description: 'We make it simple and affordable to recharge a prepaid mobile phone in the United States — even your own'
    },
    privacy_policy:{
      title: 'Closer to your family',
    },
  },

  page_section_headers:{
    about_us:{
      title: 'About us',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    faqs:{
      title: 'Frequently Asked Questions',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut pellentesque era'
    },
    contact_us:{
      title: 'Contact Us',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    terms_and_conditions:{
      title: 'Terms and Conditions',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    },
    privacy_policy:{
      title: 'Privacy Policy',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
    }
  }



}



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js